const pagesPersonImportCsvEn = {
  alertCard: {
    cells: 'cells',
    message: 'Refer to errors found below and upload a corrected file again.',
    warningMessage:
      'Some operations were skipped. Please check the warnings below.',
  },
  checkValidColumn: {
    errors: 'Errors',
    warnings: 'Warnings',
  },
  completeDialog: {
    button: 'Go to Workforce',
    message: 'Successfully Imported!',
    note: 'When there are many records, it may take a few minutes to appear in the list. Please check again after a while.',
  },
  dataTableCard: {
    noResult: 'No results.',
  },
  dockAddStepperAction: {
    next: 'NextStep',
  },
  navigation: {
    section: {
      step1: 'Upload file',
      step2: 'Preview file',
      step3: 'Import data',
    },
  },
  prepareCsvFile: {
    createTemplatePrefix: 'Create template',
    download: 'Download',
    fileSizeError: 'File size must be less than 10MB',
    template: 'Template',
    title: 'Prepare CSV file',
    updateTemplatePrefix: 'Update template',
    uploadFileHere: 'Upload file here',
    useLastUploadedFile: 'Use last uploaded file',
  },
  processing: {
    default: 'Loading...',
    import: 'Importing the data uploaded…',
    upload: 'Checking the uploaded file…',
  },
  titleCard: {
    title: {
      step1: '1. Upload file',
      step2: '2. Preview file',
      step3: '3. Import data',
    },
  },
  workerType: {
    filename: {
      // TODO: common.workerType に統一したい
      boardMember: 'BoardMember',
      collaborator: 'Collaborator',
      contractor: 'Contractor',
      employee: 'Employee',
    },
    prepareCsvFile: {
      templateTitle: {
        boardMember: 'New boardMembers',
        collaborator: 'New collaborators',
        contractor: 'New contractors',
        employee: 'New employees',
      },
      updateExisting: {
        boardMember: 'Update existing boardMembers',
        collaborator: 'Update existing collaborators',
        contractor: 'Update existing contractors',
        employee: 'Update existing employees',
      },
    },
    title: {
      boardMember: 'Bulk Add Board Member',
      collaborator: 'Bulk Add Collaborator',
      contractor: 'Bulk Add Contractor',
      employee: 'Bulk Add Employee',
    },
    unit: {
      boardMembers: 'boardMembers',
      collaborators: 'collaborators',
      contractors: 'contractors',
      employees: 'employees',
    },
  },
};

export default pagesPersonImportCsvEn;
